import {
	checkAnyUserType,
	isAccountManager,
	isAdmin,
	isFashionDesigner,
	replaceUnderLine
} from '@utils/Util';

export const DESIGN_INFO_INITIAL_STATE = {
	designNum: '',
	buyerDesignNum: '',
	selectedMarket: null,
	selectedCategory: null,
	selectedFabricType: '',
	selectedBodyFabric: [],
	selectedBrand: null,
	selectedNitexDesign: null,
	selectedDesigner: null,
	selectedTpCompleatedBy: null,
	selectedLook: null,
	selectedTags: []
};

export const TECHPACK_CHECKLIST_STATE = {
	styleBlock: null,
	stylingAndOther: '',
	stitching: '',
	print: [],
	wash: [],
	fittingType: null,
	embroidery: [],
	fabricDyeColor: [],
	trimsDyeColor: [],
	action: null,
	bodyWidth: null,
	bodyHeight: null,
	sleeves: null
};

export const SAMPLE_LIST_TABLE_STATE = {
	sampleId: '',
	country: null,
	QCApprovalDate: '',
	color: '',
	size: '',
	sampleType: null,
	brand: null,
	sampleLocation: null,
	remark: '',
	sampleStatus: null
};

export const INITIAL_STATE_FOR_CREATE_ISSUE = {
	issueStatus: {
		id: 'PENDING',
		value: 'Pending',
		className: 'blue-3'
	},
	file: [],
	issuePlace: [],
	issueDetails: '',
	responsiblePerson: [],
	notifyTo: [],
	isRedevelopment: false,
	isReWorkNeeded: false,
	reworkTaskStages: [],
	isHoldTechpack: false
};

export const NITEX_DESIGN = [
	{ id: true, name: 'YES', value: 'YES' },
	{ id: false, name: 'NO', value: 'NO' }
];

export const ISSUE_STATUS = [
	{
		id: 'PENDING',
		value: 'Pending',
		className: 'blue-3'
	},
	{
		id: 'SOLVED',
		value: 'Solved',
		className: 'green-3'
	},
	{
		id: 'COMMERCIALLY_SOLVED',
		value: 'Commercially solved',
		className: 'green-3'
	},
	{
		id: 'CANCELLED',
		value: 'Cancel Issue',
		className: 'red-3'
	}
];

export const TECHPACK_STATUS_TAG_COLORS = {
	PENDING: 'blue-3',
	COMPLETED: 'green-3'
};

export const COUNTRY_LIST = [
	{ id: 'BD', name: 'BD', value: 'BD' },
	{ id: 'UK', name: 'UK', value: 'UK' },
	{ id: 'ESP', name: 'ESP', value: 'ESP' },
	{ id: 'TR', name: 'TR', value: 'TR' },
	{ id: 'DEU', name: 'DEU', value: 'DEU' }
];

export const SAMPLE_TABLE_HEADERS = [
	'Sample ID*',
	'Country*',
	'Whom to Send Final Sample',
	'QC Approval',
	'Sample Type*',
	'Brand/Factory',
	'Color',
	'Size',
	'Sample Location*',
	'Location Updated by',
	'Remarks',
	'Sample Status'
];

export const LOCATIONS_MODAL_STATES = {
	locationId: '',
	countryId: '',
	buildingTag: {},
	floorTag: {},
	roomNoOrAreaTag: {},
	otherDetails: '',
	colorTag: {}
};

export const USER_TYPES = {
	FASHION_DESIGNER: 'FASHION_DESIGNER',
	GRAPHICS_DESIGNER: 'GRAPHICS_DESIGNER',
	GARMENTS_TECH: 'GARMENTS_TECH',
	THREE_D_DESIGNER: 'THREE_D_DESIGNER'
};

export const SAMPLE_TYPES = [
	{ id: 'NITEX_BD_DEVELOPMENT', value: 'Nitex BD Dev.' },
	{ id: 'BUYER_TP_DEVELOPMENT', value: 'Buyer TP Dev.' },
	{ id: 'COUNTER_DEVELOPMENT', value: 'Counter Dev.' },
	{ id: 'BLOCK_SAMPLE_DEVELOPMENT', value: 'Block sample Dev.' },
	{ id: 'TURKEY_DEVELOPMENT', value: 'Turkey Dev.' },
	{ id: 'FACTORY_BROUGHT_SAMPLE', value: 'Factory Brought sample' },
	{ id: 'PRODUCTION_SAMPLE', value: 'Production sample' },
	{ id: 'PP_SAMPLE', value: 'PP sample' },
	{ id: 'SHOPPING_SAMPLE', value: 'Shopping sample' },
	{ id: 'NITEX_SOLD_DESIGN', value: 'Nitex sold design' }
];

export const SAMPLE_STATUS = [
	{
		id: 'AVAILABLE',
		value: 'Available'
	},
	{
		id: 'AT_SHOWROOM',
		value: 'At Showroom'
	},
	{
		id: 'AT_STORE',
		value: 'At Store'
	},
	{
		id: 'MISSING',
		value: 'Missing'
	},
	{
		id: 'EXPIRED',
		value: 'Expired'
	},
	{
		id: 'GIVE_AWAY',
		value: 'Give Away'
	},
	{
		id: 'SEND_TO_BUYER',
		value: 'Send to Buyer'
	}
];

export const isFactory = (type) => {
	return type === 'FACTORY_BROUGHT_SAMPLE';
};

export const getSampleTypeBasedOnConditions = (sample) => {
	if (sample?.isNitexDesign) {
		return 'NITEX_BD_DEVELOPMENT';
	} else return replaceUnderLine(sample?.sampleType);
};

export const isFactoryBroughtSample = (sampleType) => {
	return sampleType === 'FACTORY_BROUGHT_SAMPLE';
};

export const isShoppingSample = (sampleType) => {
	return sampleType === 'SHOPPING_SAMPLE';
};

export const isAllowedToEditInventory = () => {
	return (
		isAdmin() ||
		isFashionDesigner() ||
		isAccountManager() ||
		checkAnyUserType([
			'PRODUCT_DEVELOPMENT',
			'MERCHANDISER',
			'BUSINESS_DEVELOPMENT_MANAGER',
			'ACCOUNT_MANAGER'
		])
	);
};

export const isDisableBrandOrFactory = (type) => {
	return (
		!type ||
		type == 'NITEX_BD_DEVELOPMENT' ||
		type === 'COUNTER_DEVELOPMENT' ||
		type === 'BLOCK_SAMPLE_DEVELOPMENT' ||
		type === 'TURKEY_DEVELOPMENT' ||
		type === 'NITEX_SOLD_DESIGN'
	);
};

export const createInitialSampleData = (rowId, productId, owner = null) => {
	return {
		productId: productId,
		sampleId: null,
		countryResponse: {},
		brandResponse: {},
		supplierResponse: {},
		qcApprovalDate: null,
		color: null,
		size: null,
		sampleType: null,
		sampleStatus: null,
		remarks: null,
		sampleInventoryLocationId: null,
		rowId: rowId,
		owner: owner
	};
};

export const LOCATIONS_TAG = {
	SAMPLE_INVENTORY_LOCATION_BUILDING_TAG: 'SAMPLE_INVENTORY_LOCATION_BUILDING_TAG',
	SAMPLE_INVENTORY_LOCATION_FLOOR_TAG: 'SAMPLE_INVENTORY_LOCATION_FLOOR_TAG',
	SAMPLE_INVENTORY_LOCATION_ROOM_OR_AREA_TAG: 'SAMPLE_INVENTORY_LOCATION_ROOM_OR_AREA_TAG',
	SAMPLE_INVENTORY_LOCATION_COLOR_TAG: 'SAMPLE_INVENTORY_LOCATION_COLOR_TAG'
};

export const isCopyedStyle = (parentId, sample) => {
	if (!parentId) return false;
	else if (parentId && parseInt(parentId) !== parseInt(sample?.productId)) return true;
};

export const locationInfo = (sample) => {
	if (sample?.locationId) {
		const country = sample?.countryResponse?.code || '';
		const building = sample?.buildingTagResponse?.text || '';
		const floor = sample?.floorTagResponse?.text || '';
		const room = sample?.roomOrAreaTagResponse?.text || '';
		const color = sample?.colorTagResponse?.text || '';
		const sl = sample?.sl || sample?.sampleSl ? `SL-${sample?.sl}` : '';
		const otherDetails = sample?.otherDetails;
		const parts = [country, building, floor, room, color, sl, otherDetails].filter(Boolean);
		const locationDetails = parts.length > 0 ? `${parts.join(', ')}` : '';
		return `${sample.locationId}, ${locationDetails}`;
	} else {
		return '';
	}
};

export const canEditSampleId = (sample, isDesignEdit, parentId) => {
	return (
		isDesignEdit &&
		isAllowedToEditInventory() &&
		!sample?.isWrongEntry &&
		!isCopyedStyle(parentId, sample)
	);
};

export const canEditDropdown = (sample, isDesignEdit, parentId) => {
	return (
		isDesignEdit &&
		isAllowedToEditInventory() &&
		!sample?.isWrongEntry &&
		!isCopyedStyle(parentId, sample)
	);
};

export const canEditQcApproval = (isDesignEdit, sample, parentId) => {
	return isDesignEdit && !sample?.isWrongEntry && !isCopyedStyle(parentId, sample);
};

export const canEditBrandOrFactory = (sample, parentId) => {
	return (
		isAllowedToEditInventory() &&
		!sample?.isWrongEntry &&
		!isDisableBrandOrFactory(sample?.sampleType) &&
		!isCopyedStyle(parentId, sample)
	);
};

export const canEditRemarks = (sample, isDesignEdit, parentId) => {
	return isDesignEdit && !sample?.isWrongEntry && !isCopyedStyle(parentId, sample);
};

export const canEditLocation = (sample, isDesignEdit, parentId) => {
	return (
		isDesignEdit &&
		isAllowedToEditInventory() &&
		!sample?.isWrongEntry &&
		!isCopyedStyle(parentId, sample)
	);
};

export const canShowActions = (sample, isDesignEdit, parentId) => {
	return isDesignEdit && isAllowedToEditInventory() && !isCopyedStyle(parentId, sample);
};

export const canEditCountry = (sample, isDesignEdit, parentId) => {
	return (
		isDesignEdit &&
		isAllowedToEditInventory() &&
		!sample?.isWrongEntry &&
		!isCopyedStyle(parentId, sample)
	);
};

export const canEditSampleOwner = (sample, isDesignEdit, parentId) => {
	return isDesignEdit && !sample?.isWrongEntry && !isCopyedStyle(parentId, sample);
};

export const createCountryResponseOnSelectSampleId = (rowId, isNitexDesign) => {
	if (rowId === 1 && isNitexDesign) {
		return {
			code: 'BD',
			id: 16,
			name: 'BD',
			value: 'BD'
		};
	} else if (rowId === 2 && isNitexDesign) {
		return {
			code: 'UK',
			id: 243,
			name: 'UK',
			value: 'UK'
		};
	} else return null;
};

export const createSampleTypeOnSelectSampleId = (isNitexDesign) => {
	if (isNitexDesign) {
		return 'NITEX_BD_DEVELOPMENT';
	} else if (!isNitexDesign) {
		return 'BUYER_TP_DEVELOPMENT';
	}
};

export const createBrandResponseOnSelectBuyerTP = (isNitexDesign, selectedBrand) => {
	if (!isNitexDesign) return selectedBrand;
};

export const getPublishStatus = (publishStatus = []) => {
	const formattedPublishStatus = [];
	publishStatus.forEach((item) => {
		formattedPublishStatus.push({ name: 'Nitex Design', successIcon: item?.isNitexProduct });
		formattedPublishStatus.push({ name: 'Sample ID', successIcon: item?.hasSample });
		formattedPublishStatus.push({ name: 'Body Fabric', successIcon: item?.hasBodyFabric });
		formattedPublishStatus.push({ name: 'Measurement', successIcon: item?.hasMeasurement });
		formattedPublishStatus.push({ name: 'Presentation', successIcon: item?.hasPresentation });
		formattedPublishStatus.push({
			name: 'Costing',
			successIcon: item?.hasBasePrice
		});
	});
	return formattedPublishStatus;
};
export const isAllCriteriaCompleted = (publishStatus = []) => {
	return publishStatus.every(
		(item) =>
			item?.hasSample &&
			item?.hasBodyFabric &&
			item?.hasMeasurement &&
			item?.hasPresentation &&
			item?.hasBasePrice &&
			item?.isNitexProduct
	);
};

export const transformDropdownOptions = (options = []) => {
	return options?.map((item) => ({
		...item,
		value: item?.name,
		label: item?.name
	}));
};

export const formatSelectedIssueToEdit = (selectedIssueToEdit) => {
	const issueStatus = ISSUE_STATUS.find((item) => item?.id === selectedIssueToEdit?.issueStatus) || {
		id: 'PENDING',
		value: 'Pending',
		className: 'blue-3'
	};

	return {
		...selectedIssueToEdit,
		issueStatus: issueStatus,
		file: [],
		issuePlace: selectedIssueToEdit?.issueTypeList?.map((item) => ({
			id: item,
			value: item,
			label: item
		})),
		issueDetails: selectedIssueToEdit?.details,
		responsiblePerson: selectedIssueToEdit?.responsibleUsersList?.map((item) => ({
			id: item?.id,
			value: item?.id,
			label: item?.name
		})),
		notifyTo: selectedIssueToEdit?.notifyUsersList?.map((item) => ({
			id: item?.id,
			value: item?.id,
			label: item?.name
		})),
		isRedevelopment: selectedIssueToEdit?.reDevelopment,
		isReWorkNeeded: selectedIssueToEdit?.rework,
		reworkTaskStages: selectedIssueToEdit?.reworkStages?.map((item) => ({
			id: item?.id,
			value: item?.id,
			label: item?.name
		})),
		isHoldTechpack: selectedIssueToEdit?.holdDevelopment
	};
};

export const formatSelectOptions = (options) => {
	return options?.map((item) => ({
		...item,
		value: item?.id || item?.constant,
		label: item?.name
	}));
};

export const validateForm = (inputValues, setErrors) => {
	const errors = {};
	if (!inputValues.issuePlace?.length) {
		errors.issuePlace = 'Please select at least one issue place';
	}
	if (!inputValues.issueDetails?.trim()) {
		errors.issueDetails = 'Please enter issue details';
	}
	if (!inputValues.responsiblePerson?.length) {
		errors.responsiblePerson = 'Please select at least one responsible person';
	}
	if (inputValues.responsiblePerson?.length === 0) {
		errors.responsiblePerson = 'Please select at least one responsible person';
	}
	if (inputValues.isReWorkNeeded && !inputValues.reworkTaskStages?.length) {
		errors.reworkTaskStages = 'Please select at least one rework task stage';
	}
	setErrors(errors);
	return Object.keys(errors).length === 0;
};

export const convertFileToBase64 = (files = []) => {
	if (!files.length) return Promise.resolve([]);

	const promises = files.map((file) => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => {
				resolve({
					name: file.name,
					docMimeType: file?.type,
					documentType: 'PRODUCT_DESIGN',
					base64Str: reader.result.split(',')[1]
				});
			};

			reader.onerror = (error) => reject(error);
		});
	});

	return Promise.all(promises);
};

export const isIssueCreator = (userInfo, selectedIssueToEdit) => {
	return parseInt(userInfo?.id) === parseInt(selectedIssueToEdit?.createdBy?.id);
};

const findUserFromList = (list = [], userInfo) => {
	return list?.find((user) => parseInt(user?.id) === parseInt(userInfo?.id));
};

export const isNotifyUser = (userInfo, selectedIssueToEdit) => {
	const getLogedInUserFromNotifyList = findUserFromList(selectedIssueToEdit?.notifyUsersList, userInfo);

	if (getLogedInUserFromNotifyList) {
		return true;
	} else {
		return false;
	}
};

export const isResponsiblePerson = (userInfo, selectedIssueToEdit) => {
	const getLogedInUserFromResponibleList = findUserFromList(
		selectedIssueToEdit?.responsibleUsersList,
		userInfo
	);

	if (getLogedInUserFromResponibleList) {
		return true;
	} else {
		return false;
	}
};

// Chart added in the TP as a image
// Chart will provide by GT

export const CHECK_LIST_ACTIONS = [
	{
		id: 'IN_TP',
		value: 'Excel chart added in the TP',
		name: 'Excel chart added in the TP'
	},
	{
		id: 'BY_PATTERN_MASTER',
		value: 'Chart will provide by 3D designer',
		name: 'Chart will provide by 3D designer'
	},
	{
		id: 'BY_FACTORY',
		value: 'Will provide by factory',
		name: 'Will provided by factory'
	},
	{
		id: 'ADDED_AS_IMAGE',
		value: 'Chart added in the TP as a image',
		name: 'Chart added in the TP as a image'
	},
	{
		id: 'BY_GT',
		value: 'Chart will provide by GT',
		name: 'Chart will provide by GT'
	},
	{
		id: 'BLOCK',
		value: 'Measurement chart added',
		name: 'Measurement chart added'
	},
	{
		id: 'AS_PER_SHOPPING_SAMPLE',
		value: 'Measurement as per shopping sample',
		name: 'Measurement as per shopping sample'
	}
];

export const formatFittingInfoEnum = (fittingItems = []) => {
	return fittingItems?.map((item) => ({
		...item,
		value: item?.name,
		id: item?.constant
	}));
};
